export default "assets/domains-map-overlay-d3aec767.png";